<template>
    <div class="modal-contact-form-container" :class="config.layout">
        <ContactCard :contact="contact"></ContactCard>
        <DropList class="request-types" :data="requestTypes" v-model="requestType" :value="requestType" :label="labels.get('Request type')" v-if="requestTypes && requestTypes.length > 1"></DropList>
        <FlatButton blue inline-right :label="labels.get('Get in contact')" @click="showContactForm"></FlatButton>
    </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import ContactCard from "./ContactCard.vue";
import { DropList, FlatButton } from "clariant-vue3-forms";

export default {
    name: "LegacyContactBox",
    components: {
        ContactCard,
        DropList,
        FlatButton
    },
    props: ["contact", "requestTypes"],
    data() {
        return {
            labels: ServiceManager.getService(this, "Labels"),
            state: ServiceManager.getService(this, "State"),
            config: ServiceManager.getService(this, "Config"),
            requestType: ""
        }
    },
  setup() {
    return {
      uniqueId: `LegacyContactBox-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`
    }
  },
    mounted() {
        this.state.subscribe(
            this.uniqueId,
            this.onStateChanged
        );
    },
    beforeUnmount() {
        this.state.unsubscribe(this.uniqueId);
    },
    methods: {
        onStateChanged(msg, prop, value) {
            if (prop === "requestTypes") {
                this.$nextTick(() => {
                    this.requestType =
                        value && value.length > 0
                            ? value[0].id
                            : "";
                    console.info("Request type defaulted to " + this.requestType);
                });
            }
        },
        showContactForm() {
            this.$emit("showContactForm", this.requestType);
        }
    }
}
</script>

<style scoped>
.modal-contact-form-container {
    border: 1px solid #c9c9c9;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.request-types {
    margin: 20px 0;
}

a.inline-right,
button.inline-right {
    align-self: flex-end;
    min-width: 160px;
}

/*.modal-contact-form-container.horizontal a.inline-right,
.modal-contact-form-container.horizontal button.inline-right {
    align-self: center;
    min-width: 160px;
    margin: 13px 0 10px 0;
}

.modal-contact-form-container.horizontal .request-types {
    width: auto;
    flex-grow: 1;
    margin: 0 20px;
}*/

@media all and (max-width:480px) {

    /*.modal-contact-form-container.horizontal .request-types {
        width: 100%;
        margin: 0;
    }

    .modal-contact-form-container.horizontal a.inline-right {
        align-self: flex-end;
    }*/
}
</style>